var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditPassword.jinja');
require('./MemberProfileEditPassword.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileEditPassword-buttons-button--cancel': 'cancelEdit',
        'click .MemberProfileEditPassword-buttons-button--save': 'saveEdit',
        'click .MemberProfileEditPassword-body-form-input-forgotPass': 'forgotPassword',
        'click .MemberProfileEditPassword-confirmPopup-body-btn': 'successChange',
        'input input': 'onInputChange'
    },

    saveApi: function () {
        return Urls['member:api:password']('json');
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'getFormData', 'saveApi');


        Base.prototype.initialize.call(this, options);
    },


    successChange: function () {
        window.app.vent.trigger('MemberProfile--updatePassword', this.options.memberId);

        this.cancelEdit();
    },


    saveEdit: function () {
        var form = this.getFormData();

        if (!form.valid) return;

        var $button = this.$('.MemberProfileEditPassword-buttons-button--save');

        $button.addClass('Button--loading');

        this.saveXhr = $.ajax({
            url: this.saveApi(),
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                old: form.data.curPass,
                new: form.data.newPass
            }),
            success: function (responseData) {
                $button.removeClass('Button--loading');

                this.$('.MemberProfileEditPassword-confirmPopup').removeClass('hidden');
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    this.$('input[name="curPass"]').addClass('error');
                }

                console.log('error', arguments);
            },
            context: this
        });
    },


    cancelEdit: function () {
        this.saveXhr && this.saveXhr.abort();

        window.app.vent.trigger('MemberProfileEdit--close', 'password');
    },


    forgotPassword: function () {
        window.app.vent.trigger('MemberProfileEdit--open', 'passwordForgot');
    },


    onInputChange: function () {
        var data = this.getFormData();
        this.$('.MemberProfileEditPassword-buttons-button--save').toggleClass('active', !!data.valid);
    },


    getFormData: function () {
        var curPass = this.$('input[name="curPass"]').val();
        var newPass = this.$('input[name="newPass"]').val();
        var confirmPass = this.$('input[name="confirmPass"]').val();

        var isConfirm = newPass == confirmPass;

        this.$('input[name="curPass"]').toggleClass('error', !curPass);
        this.$('input[name="confirmPass"]').toggleClass('error', !isConfirm);

        return {
            valid: curPass && newPass && isConfirm,
            data: {
                curPass: curPass,
                newPass: newPass
            }
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditPassword.js
// module id = 216
// module chunks = 0